/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { UserActionSummary } from '../types/universalTrackerValue';
import { AnyAction } from 'redux';

type State = ReduxStateLoadable<UserActionSummary[], UserActionSummary[]>
const getDefaultState = (): State => ({
  data: [],
  loaded: false,
  errored: false,
  errorMessage: ''
});

const userTrackersSummary = (
  state = getDefaultState(),
  action: AnyAction,
): State => {
  switch (action.type) {
    case actionTypes.LOADING_USER_TRACKER_ACTIONS_SUMMARY:
    case actionTypes.NO_DATA_USER_TRACKER_ACTIONS_SUMMARY:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_USER_TRACKER_ACTIONS_SUMMARY:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_USER_TRACKER_ACTIONS_SUMMARY:
      return {
        ...state,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.UNLOAD_USER_TRACKER_ACTIONS_SUMMARY:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default userTrackersSummary;
